module.exports = "img/flags/UA.b463046.png";